import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../data.service';
import { ActivatedRoute } from "@angular/router";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-editarencuesta',
  templateUrl: './editarencuesta.component.html',
  styleUrls: ['./editarencuesta.component.css']
})
export class EditarencuestaComponent implements OnInit {
  encuestaForm: FormGroup;
  @Input() IdEncuesta: string | null = null; 
  @Input() Encuesta: any; 
  @Output() edicionFinalizada = new EventEmitter<void>();

  constructor(private fb: FormBuilder, private data: DataService, private route: ActivatedRoute, private messageService: MessageService) {
    this.encuestaForm = this.fb.group({
      Nombre: ['', [Validators.required]],
      Descripcion: ['', [Validators.required]],
      Activa: [true, [Validators.required]],
      AgregarEncuestados: [false, [Validators.required]]
    });


  }

  ngOnInit() {
    console.log('llenar el formulario this.encuestaForm con los datos de this.Encuesta');
    console.log(this.Encuesta);
    console.log("IdEncuesta");
    console.log(this.IdEncuesta);

    this.encuestaForm.patchValue({
      Nombre: this.Encuesta['Nombre'],
      Descripcion: this.Encuesta['Descripcion'],
      Activa: this.Encuesta['Activa'],
      AgregarEncuestados: this.Encuesta['AgregarEncuestados']
    });
  }

  async onSubmit() {
    if (this.encuestaForm.valid) {
      console.log('Formulario enviado:', this.encuestaForm.value);
      //agregar a this.encuestaForm.value los campos FechaCrea, UsuarioCrea, Formulario
      this.encuestaForm.value.FechaModifica = new Date();
      this.encuestaForm.value._id = this.IdEncuesta;
      this.encuestaForm.value.IdFormulario = this.route.snapshot.paramMap.get('id');

      console.log('>>>>>>>>>>>>>>>>>>this.encuestaForm.value:>>>>>>>>>>>>>>>>>>>>>>>');
      console.log(this.encuestaForm.value);


      this.data.EditarEncuesta(this.encuestaForm.value).subscribe(response => {
        console.log(response);
        this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Encuesta guardada exitosamente'});
        this.cancelaredicion();
        this.IdEncuesta=response.id;
      }, error => {
        console.error('Error al crear la encuesta:', error);
        console.log(error);
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Error al crear la encuesta. Inténtelo nuevamente.'});
      });
    } else {
      console.log('Formulario no válido');
    }
  }

  cancelaredicion(){
    console.log('cancelar edición');
    this.edicionFinalizada.emit();
  }

  get controls() {
    return this.encuestaForm.controls;
  }

}

